import type { VoidComponent } from "solid-js";
import type { ExtendableInputProps } from "./Input";
import Input from "./Input";
import { Icon } from "../icon/Icon";
import ColorPicker from "../colorPicker/ColorPicker";

export type ColorInputProps = {
  showOpacity?: boolean;
  onChange: (value: string) => void;
  value: string;
} & ExtendableInputProps;

const ColorInput: VoidComponent<ColorInputProps> = (props) => (
  <ColorPicker
    onChange={props.onChange}
    value={props.value}
    Trigger={(triggerProps) => (
      <Input {...props} label={props.label}>
        {() => (
          <button
            {...triggerProps}
            class="flex w-full flex-row items-center gap-x-1.5 rounded-sm border border-default bg-surface-default pl-1.5 text-left focus-visible:outline-default"
          >
            <div class="size-6 rounded-sm" style={{ "background-color": props.value }} />
            <span class="grow text-base-medium text-primary">{props.value}</span>
            <div class="flex size-9 items-center justify-center p-1">
              <Icon name="chevronDown" size="md" type="solid" class="icon-secondary" />
            </div>
          </button>
        )}
      </Input>
    )}
  />
);

export default ColorInput;
